/**
 * Centralized list of Pakistani Provinces & Major Cities for ComfortSeats.
 */

export const PAKISTAN_PROVINCES = [
    "Punjab",
    "Sindh",
    "Khyber Pakhtunkhwa (KPK)",
    "Balochistan",
    "Islamabad Capital Territory",
    "Azad Jammu & Kashmir (AJK)",
    "Gilgit-Baltistan",
    "Other",
];

export const CITIES_BY_PROVINCE = {
    "Punjab": [
        "Lahore", "Faisalabad", "Rawalpindi", "Gujranwala", "Multan", "Sialkot",
        "Bahawalpur", "Sargodha", "Gujrat", "Sheikhupura", "Jhelum", "Sahiwal",
        "Kasur", "Okara", "Rahim Yar Khan", "Dera Ghazi Khan", "Chiniot", "Hafizabad",
        "Kamoke", "Mandi Bahauddin", "Muridke", "Vehari", "Khanewal", "Chakwal",
        "Attock", "Mianwali", "Muzaffargarh", "Layyah", "Bhakkar", "Jhang",
        "Pakpattan", "Bahawalnagar", "Toba Tek Singh", "Lodhran", "Khushab",
        "Taxila", "Wah Cantt", "Kot Radha Kishan", "Gojra", "Bhalwal"
    ],
    "Sindh": [
        "Karachi", "Hyderabad", "Sukkur", "Larkana", "Nawabshah (Shaheed Benazirabad)",
        "Mirpur Khas", "Shikarpur", "Jacobabad", "Ghotki", "Badin", "Dadu",
        "Tando Adam", "Khairpur", "Umerkot", "Thatta", "Kotri", "Kashmore",
        "Tando Allahyar", "Sanghar", "Mithi", "Kandiaro", "Shahdadkot", "Matiari"
    ],
    "Khyber Pakhtunkhwa (KPK)": [
        "Peshawar", "Mardan", "Mingora (Swat)", "Abbottabad", "Kohat", "Dera Ismail Khan",
        "Nowshera", "Swabi", "Charsadda", "Mansehra", "Haripur", "Bannu",
        "Batkhela", "Chitral", "Dir", "Karak", "Hangu", "Tank", "Timergara", "Risalpur"
    ],
    "Balochistan": [
        "Quetta", "Turbat", "Khuzdar", "Hub", "Chaman", "Gwadar",
        "Sibi", "Zhob", "Loralai", "Dera Allah Yar", "Pishin", "Nushki",
        "Kalat", "Usta Muhammad", "Mastung", "Kharan"
    ],
    "Islamabad Capital Territory": [
        "Islamabad"
    ],
    "Azad Jammu & Kashmir (AJK)": [
        "Muzaffarabad", "Mirpur", "Rawalakot", "Kotli", "Bhimber", "Bagh", "Palandri"
    ],
    "Gilgit-Baltistan": [
        "Gilgit", "Skardu", "Hunza", "Chilas", "Ghanche", "Ghizer", "Astore", "Nagar"
    ],
};
